import { toastrPositions } from '@gef-ui/components/organisms/Toastr';
import { getLabelMessage } from '@gef-ui/localization/messages';

export const getToastrConfig = (messageKey, type) => {
	return {
		message: getLabelMessage(messageKey),
		position: toastrPositions.TOP_RIGHT,
		closeable: true,
		timeout: 4000,
		type,
		options: {
			preventDuplicates: false,
		},
	};
};
